<template>
  <div v-if="!loading" class="info-popup">
    <v-row class="no-padding" v-for="(item, index) in rows" :key="index" align="center" justify="center">
      <v-col cols="2" class="no-padding">
        <v-icon v-if="!item.image" medium color="#0f74bb">
          {{ item.icon }}
        </v-icon>
        <v-img 
          v-else
          class="img-icon"
          max-width="30"
          max-height="30"
          src="@/assets/img/mileage.png"
        />
      </v-col>
      <v-col cols="10" class="no-padding">
        {{ mappedInfo[item.key] }}
      </v-col>
    </v-row>
  </div>
</template>

<script>

import moment from "moment";

import { locationsHelper } from '@/mixins/locations-helper.js'

export default {
  name: 'DevicePresenceInfo',
  mixins: [ locationsHelper ],
  props: {
    info: {
      type: Object,
      required: true
    }
  }, 
  data() {
    return {
      rows: [
        {
          icon: 'mdi-clock',
          key: 'last_seen_time',
          image: false
        },
        {
          icon: 'mdi-map',
          key: 'last_seen_location',
          image: false
        },
        {
          icon: 'mdi-gauge',
          key: 'speed',
          image: false
        },
        {
          icon: 'mdi-mileage',
          key: 'mileage',
          image: true
        },
        {
          icon: 'mdi-key',
          key: 'ignition',
          image: false,
          imgUrl: '@/assets/img/mileage.png'
        }
      ],
      mappedInfo: {},
      loading: true
    }
  },
  beforeMount() {
    this.mapPropsToData();
  },
  methods: {
    async mapPropsToData() {
      this.loading = true;

      if (!this.info) return;

      try {
        const location = await this.findLocations([this.info.coor], { lat: 'lat', lng: 'lng' });

        this.mappedInfo.last_seen_time = moment(this.info['data']['last_seen_local_time']).format('YYYY MMM DD HH:mm:ss');
        this.mappedInfo.last_seen_location = location[0].location;
        this.mappedInfo.speed = this.info.speed + ' km/h';
        this.mappedInfo.mileage = (this.info.mileage / 1000).toFixed(0) + ' km';
        this.mappedInfo.ignition = this.info.data.acc == 1 ? 'On' : 'Off';

        this.loading = false;
      }
      catch(err) {
        this.loading = true;
      }
    }
  }
}
</script>

<style lang="scss">
  .info-popup {
    width: 350px;
    color: #000000DE;
    font-size: 16px;
    font-weight: 400;

    .img-icon {
      left: -2px;
    }

    .no-padding {
      padding-top: .25em !important;
      padding-bottom: .25em !important;
    }
  }
</style>